import React, { Component } from 'react';

import './H1.css';

class H1 extends Component {
    render() {
        return <h1>{this.props.children}</h1>;
    }
}

export default H1;



// WEBPACK FOOTER //
// ./src/components/h1/H1.jsx